module.exports = __webpack_public_path__ + "static/10-601a8914c1971dc05bbc1f12ab5141a1.jpeg";